import React from 'react';
import { DefaultButton, PrimaryButton, Stack } from '@fluentui/react';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { IImageExperienceImage } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

import { IRecommendAd, IActivityLogger, ISetUpAdWithRecommendAdParam } from './types';
import './style.less';
import { RecommandAdPreviewCarousel } from './recommend-ad-preview-carousel';

declare let _TL_;

interface RecommendAdCarouselProps {
  i18n: any;
  url: string;
  toggleOpen: (val: boolean) => void;
  setUpAdWithRecommendAd: (param: ISetUpAdWithRecommendAdParam) => void;
  ads: IRecommendAd[];
  imageExperiences: IImageExperienceImage[];
  isMMAV2Enabled: boolean;
  activityLogger: IActivityLogger;
}

interface RecommendAdCarouselState {
  selectedIndex: number;
  creating: boolean;
  errorMessage: string;
}

export class RecommendAdCarousel extends
  React.Component<RecommendAdCarouselProps, RecommendAdCarouselState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedIndex: 0,
      errorMessage: '',
      creating: false,
    };
  }

  render() {
    const {
      url, i18n, toggleOpen, setUpAdWithRecommendAd, imageExperiences, ads, isMMAV2Enabled,
    } = this.props;

    const {
      selectedIndex,
      errorMessage,
      creating,
    } = this.state;

    return (
      <UiBlocker blocking={creating} loadingText={i18n.getString(_TL_('Creating...'))}>
        <div className="recommend-ad-carousel" >
          <h3 className="recommend-title" >{i18n.getString(_TL_('Ad Recommendation Preview'))}</h3>
          <RecommandAdPreviewCarousel
            activeIndex={selectedIndex}
            setActiveIndex={idx => this.setState({ selectedIndex: idx })}
            isMMAV2Enabled={isMMAV2Enabled}
            imageList={imageExperiences}
            ads={ads}
            url={url}
            i18n={i18n}
          />
          <hr />
          <Stack horizontal tokens={{ childrenGap: 8 }} >
            <PrimaryButton
              onClick={async () => {
                this.props.activityLogger.signal(`create this ad - recommend-ad-carusel. The final URL: ${url}.`, 'responsive ad recommendation');
                this.setState({
                  creating: true,
                });
                try {
                  await setUpAdWithRecommendAd({
                    ad: ads[selectedIndex],
                    isAdEditShown: true,
                    shouldSaveAdFromRecommend: false,
                  });
                  toggleOpen(false);
                } catch (error) {
                  this.setState({
                    errorMessage: i18n.getString(_TL_('Failed to create this ad.')),
                  });
                } finally {
                  this.setState({
                    creating: false,
                  });
                }
              }}
              text={i18n.getString(_TL_('Create this ad'))}
            />
            <DefaultButton
              onClick={() => {
                this.props.activityLogger.signal(`cancel - recommend-ad-carusel. The final URL: ${url}.`, 'responsive ad recommendation');
                toggleOpen(false);
            }}
              text={i18n.getString(_TL_('Cancel'))}
            />
            <div style={{ color: 'red' }}>{errorMessage}</div>
          </Stack>
        </div>
      </UiBlocker>

    );
  }
}
